import { writable } from "svelte/store";

const stored_workspace_name = localStorage.getItem("workspace_name");
export const workspace_name = writable(stored_workspace_name);

workspace_name.subscribe(value => {
    console.log(value)
    localStorage.setItem("workspace_name", value ? value : '');
});